import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from './services/security/authentication.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    constructor(private primengConfig: PrimeNGConfig, private authService: AuthenticationService, private gaService: GoogleAnalyticsService) {}

    ngOnInit(): void {
        //this.authService.fetchToken("constancias-app");
        this.primengConfig.ripple = true; 
        this.setSpanishCalendar();
    }

    setSpanishCalendar() {
        this.primengConfig.setTranslation({
            dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
            monthNames: [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre",
                "Octubre", "Noviembre", "Diciembre"
            ],
            monthNamesShort: [
                "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
            ],
            today: 'Hoy',
            clear: 'Limpiar',
            dateFormat: 'dd/mm/yy'
        });
    }
}
